import Api from "../services/Api";



export const loginUser = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/auth/login', userData);

      // console.log('response.results', response);

      res.status = "valid";

      res = {...res,...response};

      // localStorage.setItem('user', JSON.stringify(response.user));
      // localStorage.setItem('token', response.token);

      return res;
    } catch (error) {

      res.status = "error";
      var errorData = error.response.data;
      // console.error(error);
      res = {...res,...errorData};
      return res;
    }
};